<div class="transport-row">
    <div class="transport" *ngFor="let transport of transports" (click)="selectTransport(transport.transportId)">
        <app-transport-item [scale]="scale" [offsetBefore]="offsetBefore" [transport]="transport" [selected]="transport.transportId === selectedTransportId"></app-transport-item>
    </div>
</div>